import { baseURL } from "../../../services/host";
import DefaultImage from "../../../assets/images/Default.png";

function ProductImage({ src }) {
  const imgUrl = src ? (src.startsWith("http") ? src : `${baseURL}${src}`) : DefaultImage;
  return <img style={{ width: "100px" }} src={imgUrl} alt="product" />;
}

export default ProductImage;
